module.exports = __webpack_public_path__ + "static/media/Illus-Bread_1@3x.70a64696.png";